// src/services/firebase/authService.js
import { 
    createUserWithEmailAndPassword, 
    signInWithPopup, 
    GoogleAuthProvider,
    signInWithEmailAndPassword,
    sendPasswordResetEmail,
    signOut
  } from 'firebase/auth';
  import { auth } from './config';
  import { createUserProfile } from './userService';
  
  // Email ile kayıt
  export const registerWithEmail = async (email, password) => {
    try {
      // 1. Firebase Auth kaydı
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      
      // 2. Firestore profil oluşturma
      await createUserProfile(userCredential.user);
  
      return { success: true, user: userCredential.user };
    } catch (error) {
      console.error('Register Error:', error);
      return { success: false, error };
    }
  };
  
  // Google ile kayıt
  export const registerWithGoogle = async () => {
    try {
      const provider = new GoogleAuthProvider();
      // 1. Google ile auth
      const result = await signInWithPopup(auth, provider);
      
      // 2. Firestore profil oluşturma
      await createUserProfile(result.user);
  
      return { success: true, user: result.user };
    } catch (error) {
      console.error('Google Register Error:', error);
      return { success: false, error };
    }
  };
  
  // Email ile giriş
  export const loginWithEmail = async (email, password) => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      return { success: true, user: userCredential.user };
    } catch (error) {
      console.error('Login Error:', error);
      return { success: false, error };
    }
  };
  
  // Google ile giriş
  export const loginWithGoogle = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      return { success: true, user: result.user };
    } catch (error) {
      console.error('Google Login Error:', error);
      return { success: false, error };
    }
  };
  
  // Şifre sıfırlama
  export const resetPassword = async (email) => {
    try {
      await sendPasswordResetEmail(auth, email);
      return { success: true };
    } catch (error) {
      console.error('Password Reset Error:', error);
      return { success: false, error };
    }
  };
  
  // Çıkış yapma
  export const logout = async () => {
    try {
      await signOut(auth);
      return { success: true };
    } catch (error) {
      console.error('Logout Error:', error);
      return { success: false, error };
    }
  };